import appConfig from 'config/app';
import i18n from 'i18n';

export const MAX_ROWS_EXCEEDED = route =>
  i18n.t('constants.grid.maxRowsExceeded', { maxRows: appConfig(i18n.t).grid[route].maxRows });
